import { render, staticRenderFns } from "./TodoModal.vue?vue&type=template&id=145a69b0&"
import script from "./TodoModal.vue?vue&type=script&lang=js&"
export * from "./TodoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports